import { render, staticRenderFns } from "./ShareRecord.vue?vue&type=template&id=7b34405e&scoped=true"
import script from "./ShareRecord.vue?vue&type=script&lang=js"
export * from "./ShareRecord.vue?vue&type=script&lang=js"
import style0 from "./ShareRecord.vue?vue&type=style&index=0&id=7b34405e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b34405e",
  null
  
)

export default component.exports